import { render, staticRenderFns } from "./TinyFooter.vue?vue&type=template&id=12f37090&"
import script from "./TinyFooter.vue?vue&type=script&lang=js&"
export * from "./TinyFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports